export function paramsToObject<K extends string>(
    entries: IterableIterator<[K, string]>,
) {
    const obj: Partial<Record<K, string>> = {};
    for (const [key, value] of entries) {
        obj[key] = value;
    }
    return obj;
}
